export default "__VITE_ASSET__Cpmg48Wm__"